export default "__VITE_ASSET__C14mWshn__"